<template>
  <first-page>
    <disabled-login v-if="isDisabled"/>
    <select-login v-else/>
    <external-registration-modal/>
  </first-page>
</template>

<script>
import FirstPage from "@/components/pages/FirstPage";
import SelectLogin from "@/components/login/SelectLogin";
import {mapState} from "vuex";
import ExternalRegistrationModal from "@/components/modal/ExternalRegistrationModal";
import DisabledLogin from "@/components/login/DisabledLogin";
import {ADDITIONAL_FIELDS_LIMIT} from "@/utils/ReflinkFields";

export default {
  name: "LoginPage",
  components: {DisabledLogin, ExternalRegistrationModal, SelectLogin, FirstPage},
  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'SET_SETTINGS') {
        this.saveReflinkFieldsInSessionStorage();
      }
    })
  },
  methods: {
    saveReflinkFieldsInSessionStorage() {
      if (this.$route.params.referrer) {
        sessionStorage.setItem(`referrer-${this.entityUuid}`, this.$route.params.referrer)
      }

      for (let i = 1; i <= ADDITIONAL_FIELDS_LIMIT; i++) {
        if (this.$route.query.hasOwnProperty(`client_additional_field_${i}`)) {
          sessionStorage.setItem(`additional-${this.entityUuid}-${i}`, this.$route.query[`client_additional_field_${i}`] + '')
        }
      }
    }
  },
  computed: {
    ...mapState({
      isDisabled: state => state.settings.enabled !== '1',
      entityUuid: state => state.auth.entity.uuid,
    })
  }
}
</script>

<style scoped>

</style>
